<script setup lang="ts">
import { onBeforeMount } from 'vue';
import { useAuthStore } from '@/presentation/stores/authStore';
import GlobalToast from '@/presentation/components/organisms/GlobalToast.vue';
import ConfirmDialog from '@/presentation/components/organisms/ConfirmDialog.vue';

const auth = useAuthStore();

onBeforeMount(async () => {
  await auth.bootstrap();
});
</script>

<template>
  <div class="ava-app">
    <RouterView />
    <GlobalToast />
    <ConfirmDialog />
  </div>
</template>
